import { RepeatWrapping, Texture, TextureLoader } from "three"
import SeamlessStoneCliffFaceMountainTexture1600 from "./SeamlessStoneCliffFaceMountainTexture1600.jpg"

let texture : Texture
const texturePromise = new Promise<Texture>((resolve, reject) => {
  texture = new TextureLoader().load(SeamlessStoneCliffFaceMountainTexture1600, (texture) => {
    texture.wrapS = texture.wrapT = RepeatWrapping
    // console.log('texture', texture)
    resolve(texture)
  }, undefined, (error) => {
    // console.error(error)
    reject(error)
  })
})

export function getSeamlessStoneCliffFaceMountainTexture1600Texture () {
  return texture
}

export function getSeamlessStoneCliffFaceMountainTexture1600TexturePromise () {
  return texturePromise
}